import { createGtm } from '@gtm-support/vue-gtm'
import { isKare } from '~/utils'

export default defineNuxtPlugin((nuxtApp) => {
  const environment = nuxtApp.$config.public.env

  const kareId = environment === 'production' ? 'GTM-52SZ4JNP' : 'GTM-K75QPTBS'

  const wonderId =
    environment === 'production' ? 'GTM-PDTQZMM4' : 'GTM-MM2LZ536'

  const selectedId = isKare() ? kareId : wonderId

  console.log('Debug GTM:', {
    isKare: isKare(),
    selectedId,
    environment,
  })

  nuxtApp.vueApp.use(
    createGtm({
      id: selectedId,
      defer: false,
      compatibility: false,
      enabled: true,
      debug: false,
      loadScript: true,
      vueRouter: useRouter(),
      ignoredViews: [],
      trackOnNextTick: false,
    }),
  )
})
